import React, { useState, useEffect, useRef } from 'react';
import { Container } from "react-grid-system";
import api from "../../services/api";
import GenericUpper from "../../components/generic-upper";
import PaginatorV2 from "../../components/paginator/indexV2";
import { ContainerNotificacao, ListaNotificacoes, ContainerPaginator } from "./styles";
import AcordionNotification from "../../components/acordionNotification";
import ImageNotFound from '../../assets/not_found.svg';

const PER_PAGE = 10;

const Notificacao = ({...props}) => {

    const [not, setNot] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const ultimaBusca = useRef(null);

    const getNotifications = async (limit = PER_PAGE, offset = 0) => {
        ultimaBusca.current = limit + "-" + offset;

        try {
            const response = await api.get("/notificacoes?limit="+limit+"&offset="+offset);
            const varia = await response.data.data;
            const totalNotificacoes = await response.data.total;

            if (varia && varia.length > 0) {
                setNot(varia);
            } else {
                if (varia === false) {
                    setNot(false);
                }else{
                    setNot([varia]);
                }
            }

            if (typeof totalNotificacoes === 'number') {
                setTotal(totalNotificacoes);
            } else {
                setTotal(varia && varia.length ? varia.length : 0);
            }
        } catch (error) {
        }
    }

    useEffect(()=>{
        getNotifications(PER_PAGE, 0);
        localStorage.setItem('@notif_count', '0');
    },[])

    // O PaginatorV2 dispara o onChange da primeira pagina ao montar,
    // entao ignoramos a chamada quando ela repete a busca ja carregada.
    const changePage = (limit, offset) => {
        if (ultimaBusca.current === limit + "-" + offset) return;

        setPage(Math.floor(offset / limit) + 1);
        getNotifications(limit, offset);
    }

    return(
       <>
       <GenericUpper
                    title="Notificações"
                    subtitle="Noticias, novidades e alertas"
        ></GenericUpper>
       {not ? (
        <ContainerNotificacao>
            <Container>
              <ListaNotificacoes>
                {not.map(n=>(
                    <AcordionNotification
                        key={n.agro_notifications.id}
                        visu={n.view}
                        id={n.agro_notifications.id}
                        titulo_notificacao={n.agro_notifications.titulo_notificacao}
                        data={n.agro_notifications.data}
                        texto={n.agro_notifications.texto}
                    />
                ))}

                {total > PER_PAGE && (
                    <ContainerPaginator>
                        <PaginatorV2
                            perPage={PER_PAGE}
                            total={total}
                            currentPage={page}
                            totalItens={not.length}
                            onChange={(limit, offset) => changePage(limit, offset)}
                        />
                    </ContainerPaginator>
                )}
              </ListaNotificacoes>
            </Container>
        </ContainerNotificacao>
       ) : (
            <>
                <div className="loading" style={{
                        width: '100%',
                        height: '25vh',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                    <h4 style={{ textAlign: 'center' }}>Nenhuma notificação encontrada</h4>
                </div>
                <div style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <img src={ImageNotFound} width="300" />
                </div>
            </>
       )}
       </>
    )
}

export default Notificacao;
